import { z } from 'zod'
import { AuftragX_95Schema } from '../../Auftraege'
import {
  KmSchema,
  SignalSchema,
  ZugmeldestelleSchema,
  FreitextSchema,
  KmhSchema
} from '../../Generic/schema/generic.schema'
import {
  FREITEXT_SHORT_REGEXP,
  FREITEXT_SHORT_MAX_LENGTH
} from '../../../../utils'
import { allowedChars } from '../../../../utils/customValidationMessage'

export const Freitext100Schema = z
  .string()
  .max(FREITEXT_SHORT_MAX_LENGTH)
  .superRefine(allowedChars(FREITEXT_SHORT_REGEXP))
  .default('')

// Default constants
const DEFAULT_ZUGMELDESTELLE = {
  art: '' as const,
  name: ''
}

const DEFAULT_AUFTRAG_6_40 = {
  enabled: true,
  selector: '' as const,
  x_43_zugmeldestelle: DEFAULT_ZUGMELDESTELLE,
  x_44_zugmeldestelle: DEFAULT_ZUGMELDESTELLE,
  x_47_type: '' as const,
  x_47_1_km: '',
  x_47_2_signal: '',
  x_48_type: '' as const,
  x_48_1_km: '',
  x_48_2_signal: ''
}

const DEFAULT_AUFTRAG_6_41 = {
  enabled: false,
  x_42_1_kmh: ''
}

const DEFAULT_AUFTRAG_6_90 = {
  enabled: false,
  x_91_freitext: '',
  x_92_freitext: ''
}

const DEFAULT_BEFEHL_6_FORM = {
  auftrag_6_40: DEFAULT_AUFTRAG_6_40,
  auftrag_6_41: DEFAULT_AUFTRAG_6_41,
  auftrag_6_90: DEFAULT_AUFTRAG_6_90,
  auftrag_6_95: {
    enabled: false,
    freitext: ''
  }
}

// Schema definitions
const Auftrag6_40Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_6_40.enabled),
    selector: z
      .enum(['', 'in', 'zwischen'])
      .default(DEFAULT_AUFTRAG_6_40.selector),
    x_43_zugmeldestelle: ZugmeldestelleSchema,
    x_44_zugmeldestelle: ZugmeldestelleSchema,
    x_47_type: z
      .enum(['', 'km', 'signal'])
      .default(DEFAULT_AUFTRAG_6_40.x_47_type),
    x_47_1_km: KmSchema,
    x_47_2_signal: SignalSchema,
    x_48_type: z
      .enum(['', 'km', 'signal'])
      .default(DEFAULT_AUFTRAG_6_40.x_48_type),
    x_48_1_km: KmSchema,
    x_48_2_signal: SignalSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_6_40))

const Auftrag6_41Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_6_41.enabled),
    x_42_1_kmh: KmhSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_6_41))

const Auftrag6_90Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_6_90.enabled),
    x_91_freitext: FreitextSchema,
    x_92_freitext: Freitext100Schema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_6_90))

// Base schema
const Befehl6FormSchemaBase = z
  .object({
    auftrag_6_40: Auftrag6_40Schema,
    auftrag_6_41: Auftrag6_41Schema,
    auftrag_6_90: Auftrag6_90Schema,
    auftrag_6_95: AuftragX_95Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_6_FORM))

export const Befehl6FormSchema = Befehl6FormSchemaBase

// Validation schema factory
export const createBefehl6FormValidationSchema = () => {
  return Befehl6FormSchemaBase
}

export type Befehl6FormData = z.infer<typeof Befehl6FormSchemaBase>
